export default class CustomLoadBoardSerializer {
  static serialize(data) {
    const payload = {
      ...data
    };
    
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data
    };
  }
}